// extracted by mini-css-extract-plugin
export var container = "_6p-0";
export var fallback = "_6p-5";
export var fallbackIcon = "_6p-6";
export var hidden = "_6p-2";
export var image = "_6p-3";
export var loaded = "_6p-4";
export var placeholder = "_6p-1";